import { impersonateUser, stopImpersonation, setImpersonationError } from './reducer';

let originalUser: any = null;

export const impersonateUserThunk = (userData: any) => async (dispatch: any) => {
  try {
    //debugger;
    dispatch(impersonateUser(userData));
    sessionStorage.setItem("impersonatedUser", JSON.stringify(userData));
  } catch (error: any) {
    dispatch(setImpersonationError(error.message));
  }
};

export const stopImpersonationThunk = () => async (dispatch: any) => {
  try {
    //debugger;
    dispatch(stopImpersonation());
    sessionStorage.removeItem("impersonatedUser");
    sessionStorage.removeItem("currentContractor");
    if (originalUser) {
      sessionStorage.setItem("authUser", JSON.stringify(originalUser));
    }
  } catch (error: any) {
    dispatch(setImpersonationError(error.message));
  }
};

export const setOriginalUser = (user: any) => {
  originalUser = user;
};